import { useEffect, useState } from "react";
import axios from "axios";
import { Divider, Button } from "@mui/material";
import useGlobalContext from "../../../../hooks/useGlobalContext";
import ScrollablePageTab from "../ScrollablePageTab";
import DynamicFormPageReview from "./DynamicFormPageReview";
import localize from "../../../../common/localize";
import PageTitleSubtitle from "../../../../components/PageTitleSubTitle";

export default function DynamicFormReview({
  statusChangeId,
  eventId,
  dynamicFormModel,
  showSaveButton,
  finishButtonClick,
  allFieldsDisabled,
}) {
  const { DYNAMIC_FORM_ENDPOINT, config } = useGlobalContext();
  const [dynamicForm, setDynamicForm] = useState(dynamicFormModel);
  const [dynamicFormPages, setDynamicFormPages] = useState(undefined);

  const [selectedPage, setSelectedPage] = useState(0);

  const getDynamicFormPages = async () => {
    try {
      const pagesData = await axios.get(
        `${DYNAMIC_FORM_ENDPOINT}/${dynamicForm.Id}/page`,
        config
      );

      setDynamicFormPages(pagesData?.data?.Data);
    } catch (error) {
      setDynamicFormPages([]);
    }
  };

  useEffect(() => {
    if (dynamicFormPages && dynamicFormPages.length > 0) {
      setSelectedPage(0);
    }
  }, [dynamicFormPages]);

  useEffect(() => {
    if (dynamicForm) {
      getDynamicFormPages();
    }
  }, [dynamicForm]);

  return (
    <div
      className="flex flex-col"
      style={{ width: !statusChangeId ? "100%" : "800px" }}
    >
      <PageTitleSubtitle
        title={dynamicFormModel?.Name}
        subtitle={dynamicFormModel?.Description}
        useEventTitleStyle
      />
      <Divider />
      {dynamicFormPages && dynamicFormPages.length > 0 && (
        <div className="flex flex-col">
          <ScrollablePageTab
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
            dynamicFormPages={dynamicFormPages}
          />

          <DynamicFormPageReview
            setDynamicForm={setDynamicForm}
            dynamicFormModel={dynamicForm}
            eventId={eventId}
            formPage={dynamicFormPages[selectedPage]}
            allFieldsDisabled={allFieldsDisabled}
            statusChangeId={statusChangeId}
          />
        </div>
      )}

      {showSaveButton && (
        <div className="flex justify-between mt-10">
          <Button variant="contained" color="error" onClick={finishButtonClick}>
            {localize.finish_review}
          </Button>

          <Button variant="contained" color="success" onClick={() => {}}>
            {localize.save_changes}
          </Button>
        </div>
      )}
    </div>
  );
}
